import { Brand } from '#/lib/brand';

export const mapFleetTypeSlugToBrand = (fleetTypeSlug: unknown): Brand => (fleetTypeSlug === 'motorhome' ? 'star' : 'jucy');
